import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-business-type-wise-product-discount-trace-log',
  templateUrl: './business-type-wise-product-discount-trace-log.component.html',
  styleUrls: ['./business-type-wise-product-discount-trace-log.component.scss']
})
export class BusinessTypeWiseProductDiscountTraceLogComponent implements OnInit {
  dataSource: Object;

  constructor(private global: GlobalService, private http: HttpService) {
    this.global.set_master_page_title = 'Booth Agent Discount Trace';
    this.http.getBusinessTypeWiseProductDiscountTraceLog().subscribe((data)=> {
      console.log(data);
      this.dataSource = data
    }, (error) => {
      console.error(error);
    });
   }

  ngOnInit() {
  }

}
